export const distancePoints = (
  userLat: any,
  userLong: any,
  storeLat: any,
  storeLong: any,
) => {
  // distance between latitudes
  // and longitudes
  const dLat = ((storeLat - userLat) * Math.PI) / 180.0;
  const dLon = ((storeLong - userLong) * Math.PI) / 180.0;

  // convert to radiansa
  userLat = (userLat * Math.PI) / 180.0;
  storeLat = (storeLat * Math.PI) / 180.0;

  // apply formulae
  const a =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.pow(Math.sin(dLon / 2), 2) * Math.cos(userLat) * Math.cos(storeLat);
  const rad = 6371;
  const c = 2 * Math.asin(Math.sqrt(a));
  //return in 1000
  const distanceInKm = rad * c;
  const distInMeter = distanceInKm * 1000;
  return distInMeter;
};
